/* eslint-disable @typescript-eslint/naming-convention */
export enum UserType {
  User = 'User',
  SuperUser = 'SuperUser',
  Expert = 'Expert',
  Demoted = 'Demoted',
  Admin = 'Admin'
}
